// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthServiceService as AuthGuard } from './login/auth-service.service';
const routes: Routes = [
  // {path: 'auth', loadChildren: 'app/views/pages/auth/auth.module#AuthModule'},
  { path: 'login', component: LoginComponent, pathMatch: 'full' },

  /** START: remove this themes list on production */
  { path: '', redirectTo: 'default', pathMatch: 'full',canActivate: [AuthGuard]},
  // list of routers specified by demos, for demo purpose only!
  {
    path: 'default',
    loadChildren: 'app/views/themes/default/theme.module#ThemeModule'
  },
  {
    path: 'demo2',
    loadChildren: 'app/views/themes/demo2/theme.module#ThemeModule'
  },
  /** END: themes list end */

  { path: '**', redirectTo: 'default/error/403', pathMatch: 'full' }
  // {path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

//{ enableTracing: true }
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
